import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import { ProductUpdateComponent } from '../../product-update/product-update.component';

@Component({
  selector: 'app-edit-action',
  templateUrl: './edit-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class EditActionComponent {
  @Input() product!: IProduct;
  @Input() displayMode: 'menu-item' | 'icon-button' = 'menu-item';
  @Output() productUpdated = new EventEmitter<IProduct>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
  ) {}

  onEdit(): void {
    const dialogRef = this.dialog.open(ProductUpdateComponent, {
      data: this.product,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.productUpdated.emit(result);
      }
    });
  }
}
